import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISingleSettingResponse } from "../models/Setting";

export default function useSingleSetting(settingKey: string, loading: boolean = false) {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 60 * 1; //1 hour

  const singleSetting = useQuery({
    queryKey: ["settingKey", settingKey],
    queryFn: () => get<ISingleSettingResponse>(`/setting/${settingKey}`),
    enabled: !loading,
    staleTime: staleTime
  });

  return {
    singleSetting
  };
}
